<template>
  <vs-row>
    <vs-col vs-w="9">
      <vs-row v-if="dashboardResource.$hasLink('leaderboard')">
        <vs-col class="m-4">
          <dashboard-leaderboard-card :dashboard-resource="dashboardResource"></dashboard-leaderboard-card>
        </vs-col>
      </vs-row>
      <vs-row v-if="dashboardResource.$hasLink('referrals') || dashboardResource.$hasLink('referrals-stat')">
        <vs-col class="m-4">
          <dashboard-referral-card :dashboard-resource="dashboardResource"></dashboard-referral-card>
        </vs-col>
      </vs-row>
      <vs-row v-if="dashboardResource.$hasLink('members') || dashboardResource.$hasLink('members-stat')">
        <vs-col class="m-4">
          <dashboard-member-card :dashboard-resource="dashboardResource"></dashboard-member-card>
        </vs-col>
      </vs-row>
    </vs-col>
    <vs-col vs-w="3">
      <vs-row v-if="dashboardResource.$hasLink('referral-send')">
        <vs-col class="m-4">
          <vs-button @click="$router.push({name:'app-send-referral'})" class="w-full" style="height:80px" size="large" color="primary" type="relief">
            <div style="font-size: 20px;font-weight: bold;">{{ $t('dashboard.buttons.send_referral') }}</div>
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row v-if="dashboardResource.$hasLink('document-categories')">
        <vs-col class="m-4">
          <dashboard-resources-card :dashboard-resource="dashboardResource"></dashboard-resources-card>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>
<script>
import DashboardReferralCard from '@/views/app/dashboard/referral/dashboard-referral-card';
import DashboardMemberCard from '@/views/app/dashboard/member/dashboard-member-card';
import DashboardResourcesCard from '@/views/app/dashboard/resources/dashboard-resources-card';
import DashboardLeaderboardCard from '@/views/app/dashboard/leaderboard/dashboard-leaderboard-card';
import {ResourceImpl} from 'hal-client';

export default {
  components: {
    DashboardResourcesCard,
    DashboardMemberCard,
    DashboardReferralCard,
    DashboardLeaderboardCard
  },
  props: {
    dashboardResource: ResourceImpl
  }
};
</script>
